var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered"},[_c('progress-bar',{attrs:{"progress-key":_vm.archiveKey,"app-id":_vm.appId,"online-status":_vm.status,"progress-director":_vm.DIRECTOR.deploying,"last-modified":_vm.lastModifiedTime}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }